/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 12/4/2022 上午 11:00 下午 1:57 🚌🚄🚈🚝 */

<template>
	<div class="note">
		{{ note }}
	</div>
</template>

<script>
export default {
	name: 'temp',
	props: {
		note: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="less">
.note {
	font-size: 16px;
	line-height: 25px;
	&:first-letter{
		font-size: 20px;
		font-weight: bold;
	}
}
</style>
